import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import WatchNowIcon from 'components/icons/WatchNow';
import ActionButton from './ActionButton';

const StyledBtnText = styled.div`
  margin-left: 10px;
`;

const WatchNowButton = ({ from, url }) => {
  const onWatchNowClick = () => {
    window.trackingEvent('WatchNowButton', from, url);
    window.open(url, '_blank', 'noopener=yes,noreferrer=yes');
  };

  return (
    <ActionButton onClick={() => onWatchNowClick()}>
      <WatchNowIcon color="#FFF" />
      <StyledBtnText>
        Watch now
      </StyledBtnText>
    </ActionButton>
  );
};

WatchNowButton.propTypes = {
  from: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default WatchNowButton;
